import type { ApiEnvelope } from '@/types/api.types';
import { apiClient } from '@lib/axios';

interface ActivateAccountData {
  account: {
    accountId: string;
    status: string;
    updatedAt: string;
  };
}

export async function activateAccount(
  accountId: string,
): Promise<ApiEnvelope<ActivateAccountData>> {
  const { data } = await apiClient.post<ApiEnvelope<ActivateAccountData>>(
    `/accounts/${accountId}/activate`,
  );
  return data;
}
